import WrapWithDropdownBody from "../WrapWithDropdownBody.vue";
import { SelectedSection } from "../sections";
import ListSection from "../sections/ListSection.vue";
import ProductFilterItem from "../items/ProductFilterItem.vue";
export default {
  name: "ProductFilterBody",
  components: {
    WrapWithDropdownBody,
    SelectedSection,
    ListSection,
    ProductFilterItem
  },
  emits: ["clear", "discard", "select", "selectAll", "selectOnly", "deselect", "restoreSearch", "search", "apply", "hidden", "closeDropdown"],
  props: {
    title: {
      type: String,
      default: ""
    },
    selected: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    pendingChanges: {
      type: [Object, String],
      default: null
    },
    searching: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: [String, Array],
      default: ""
    }
  }
};